<template>
<div class="panel">
  <div class="panel-header">
    <img class="panel-img" src="../../images/ucenter/uc-hint-left.png" alt="">
    <p class="panel-title">{{title}}</p>
    <img class="panel-img" src="../../images/ucenter/uc-hint-right.png" alt="">
  </div>
  <div class="panel-center" v-if="!isCustomerService">
    <ul class="panel-menu">
      <li class="flexbox panel-item" v-for="priv in list" :key="priv.icon">
        <img class="panel-item-img" :src=priv.icon alt="">
        <div>
          <p class="panel-item-title">{{priv.title}}</p>
          <p class="panel-item-subtitle">{{priv.subtitle}}</p>
        </div>
      </li>
    </ul>
  </div>
  <div v-else class="panel-bottom">
    <p>扫码添加专属客服微信</p>
    <img class="teacher-img" :src="teacher" alt="">
  </div>
</div>
</template>

<script>
export default {
  name: 'PrivilegePanel',
  props: {
    title: String,
    isCustomerService: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    teacher: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.panel {
  .panel-header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.62rem;
    .panel-title {
      font-family: PingFangSC-Medium,PingFang SC;
      font-size: .3rem;
      color: #C3A472;
      margin: 8px;
    }
    .panel-img {
      width: 1rem;
      opacity: 1;
    }
  }
  .panel-center {
    margin: 0px 7px -10px 7px;
    .panel-menu {
      display: flex;
      flex-direction: column;
      padding:0 0.32rem;
      .panel-item {
        align-items: center;
        width:100%;
        margin: 0 0 20px 0;
        .panel-item-img {
          width: 1rem;
          height: 1rem;
          flex-shrink: 0;
          margin-right: 0.32rem;
        }
        .panel-item-title {
          font-weight: 600;
          font-size: 0.28rem;
          margin-bottom: 0.15rem;
        }
        .panel-item-subtitle {
          font-size: 0.24rem;
          color:#363535;
        }
      }
    }
  }
  .panel-bottom {
    margin: -6px 0 0 0;
    height: 3.8rem;
    text-align: center;
    font-size: 0.24rem;
    .teacher-img {
      width: 30%;
      margin-top: .24rem;
    }
  }
}
</style>
